import React from 'react';
import { Menu } from 'lucide-react';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger, SheetClose } from './ui/sheet';

/**
 * Wraps a dashboard's header action buttons so they collapse
 * into a hamburger menu on small screens.
 * - md+ : shows the children inline (horizontal flex)
 * - <md : shows a hamburger that opens a side sheet containing
 *         the same buttons (full-width, stacked). Each tap auto-
 *         closes the sheet because SheetClose wraps every button.
 */
export default function MobileActionMenu({ children, title = 'Menu' }) {
  return (
    <>
      {/* Desktop / tablet row */}
      <div className="hidden md:flex items-center gap-2 lg:gap-3 flex-wrap">
        {children}
      </div>

      {/* Mobile hamburger */}
      <div className="md:hidden">
        <Sheet>
          <SheetTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              className="rounded-full"
              data-testid="mobile-menu-trigger"
              aria-label="Open menu"
            >
              <Menu className="w-5 h-5" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[280px] sm:w-[320px] overflow-y-auto">
            <SheetHeader>
              <SheetTitle>{title}</SheetTitle>
            </SheetHeader>
            <div
              className="flex flex-col gap-2 mt-6 [&_button]:w-full [&_button]:justify-start [&_a]:w-full [&_a]:justify-start"
              data-testid="mobile-menu-content"
            >
              <SheetClose asChild>
                <div className="contents">{children}</div>
              </SheetClose>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </>
  );
}
